import React, { useEffect, useState } from "react";
import { FaNewspaper, FaCalendarAlt } from "react-icons/fa";
import "./blog.css";

const newsData = [
  {
    image: "https://trainingmag.com/wp/wp-content/uploads/2023/10/shutterstock_1917248702-696x464.jpg",
    title: "Foreign Collaborations and Business Expansion",
    description: "Explore the legal aspects and benefits of foreign collaborations for expanding your business globally.",
    date: "29 Apr 2025",
  },
  {
    image: "https://assets-news.housing.com/news/wp-content/uploads/2016/08/23202816/joint-ventures-real-estate-F.jpg",
    title: "Joint Ventures: A Pathway to Growth",
    description: "Understand the key considerations and legal frameworks involved in forming joint ventures for mutual business growth.",
    date: "27 Apr 2025",
  },
  {
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8qpWRyoEPeAsGJPeggdsw4V5psrVZSZ8U6w&s",
    title: "Navigating Corporate Law for Success",
    description: "Learn the essentials of corporate law, including compliance, governance, and the role of legal counsel in businesses.",
    date: "25 Apr 2025",
  },
  // {
  //   image: "https://www.shutterstock.com/image-photo/business-technology-internet-communications-600nw-1224229714.jpg",
  //   title: "Information Technology and Legal Framework",
  //   description: "Get insights into the legal issues surrounding the information technology sector, from data protection to compliance.",
  //   date: "22 Apr 2025",
  // },
  // {
  //   image: "https://www.shutterstock.com/image-photo/partnership-handshake-meeting-new-deal-600nw-1123560973.jpg",
  //   title: "Business Ventures and Legal Considerations",
  //   description: "Understand the essential legal factors to consider when starting a business venture, from incorporation to contracts.",
  //   date: "20 Apr 2025",
  // },
  // {
  //   image: "https://www.shutterstock.com/image-photo/india-business-ladies-woman-sitting-on-600nw-1445703987.jpg",
  //   title: "MSME Legal Assistance: Empowering Small Businesses",
  //   description: "Discover the legal support available for Micro, Small, and Medium Enterprises (MSMEs) to grow and thrive.",
  //   date: "18 Apr 2025",
  // },
  // {
  //   image: "https://www.shutterstock.com/image-photo/business-lawyer-and-client-shaking-hands-600nw-1246472431.jpg",
  //   title: "Mediation and Dispute Resolution Strategies",
  //   description: "Learn about alternative dispute resolution methods such as mediation and arbitration for resolving business conflicts.",
  //   date: "15 Apr 2025",
  // },
  // {
  //   image: "https://www.shutterstock.com/image-photo/young-startup-founder-working-with-team-600nw-1404709127.jpg",
  //   title: "Start-up India Initiatives: Legal Guide",
  //   description: "Explore the government-backed initiatives and legal support for Indian startups to scale successfully.",
  //   date: "12 Apr 2025",
  // },
  // {
  //   image: "https://www.shutterstock.com/image-photo/real-estate-business-property-contracts-600nw-1290043875.jpg",
  //   title: "Property and Real Estate Law Essentials",
  //   description: "Understand the key legal issues and regulations in property and real estate transactions, from ownership to leases.",
  //   date: "10 Apr 2025",
  // },
];

const Blog = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.2 }
    );

    const section = document.querySelector(".lawnews-section");
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <section className={`lawnews-section ${isVisible ? "visible" : ""}`}>
      <div className="lawnews-container">
        <div className="lawnews-title">
          <FaNewspaper className="lawnews-icon" />
          <h2>InduRatna <span>Blog Section</span></h2>
        </div>
        <div className="lawnews-list">
          {newsData.map((news, index) => (
            <div className="lawnews-item slide-in" key={index}>
              <img src={news.image} alt={news.title} className="lawnews-image" />
              <div className="lawnews-content">
                <h3>{news.title}</h3>
                <p>{news.description}</p>
                <div className="lawnews-meta">
                  <FaCalendarAlt className="lawnews-meta-icon" />
                  <span>{news.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
